/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Github_Auth_EnabledInputs */

const en_admin_settings_fields_github_auth_enabled = /** @type {(inputs: Admin_Settings_Fields_Github_Auth_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable GitHub auth`)
};

const zh_admin_settings_fields_github_auth_enabled = /** @type {(inputs: Admin_Settings_Fields_Github_Auth_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 GitHub 认证`)
};

/**
* | output |
* | --- |
* | "Enable GitHub auth" |
*
* @param {Admin_Settings_Fields_Github_Auth_EnabledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_github_auth_enabled = /** @type {((inputs?: Admin_Settings_Fields_Github_Auth_EnabledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Github_Auth_EnabledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_github_auth_enabled(inputs)
	return zh_admin_settings_fields_github_auth_enabled(inputs)
});
export { admin_settings_fields_github_auth_enabled as "admin.settings.fields.github_auth_enabled" }